// extracted by mini-css-extract-plugin
export var closeButton = "_jo-1";
export var closeX = "_jo-3";
export var container = "_jo-0";
export var image = "_jo-2";